import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock, WashingMachine } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") navigate("/admin/panel");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/panel");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <span className="bg-cyan-500 text-white p-2 rounded-lg">
            <WashingMachine className="h-6 w-6" />
          </span>
          <span className="font-heading font-bold text-xl text-slate-900">Lavandería Ozono</span>
        </Link>
        <form onSubmit={submit} className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm space-y-5">
          <div className="text-center mb-2">
            <span className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-cyan-50 text-cyan-600 mb-3">
              <Lock className="h-5 w-5" />
            </span>
            <h1 className="text-2xl font-heading font-bold text-slate-900">Panel de Administración</h1>
            <p className="text-sm text-slate-500 mt-1">Acceso exclusivo para el personal</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-email">Correo electrónico</Label>
            <Input id="admin-email" data-testid="admin-email-input" type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@cleanmaster.es" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-password">Contraseña</Label>
            <Input id="admin-password" data-testid="admin-password-input" type="password" required
              value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          <Button type="submit" disabled={loading} data-testid="admin-login-btn"
            className="w-full bg-cyan-500 hover:bg-cyan-600 rounded-full h-11">
            {loading ? "Accediendo..." : "Iniciar Sesión"}
          </Button>
        </form>
      </div>
    </div>
  );
}
